import innerHTML from 'utils/DOM/innerHTML'

function renderHeaderProducts(template, products = []): void {
  innerHTML('#header__menu', template({ products }))
}

export default renderHeaderProducts
